import React, { Component } from 'react';
import { connect } from 'react-redux'

class BlockingPanel extends Component{
  constructor(props){
    super(props);
    this.state = {
    }
  }
  render() {
    var zIndex = this.props.blockingPanelReducer.zIndex ? this.props.blockingPanelReducer.zIndex : "";
    var txt = {"zIndex" :  zIndex };
    return (
      <div className="blockingPanel" style={txt}>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    blockingPanelReducer : state.blockingPanelReducer
  }
}

export default BlockingPanel = connect(
  mapStateToProps,
  null
)(BlockingPanel);



// WEBPACK FOOTER //
// ./src/components/workSpace/Others/BlockingPanel.jsx